import React from 'react';
import { Star } from 'lucide-react';
import { useSettings } from '../context/SettingsContext';

const GoogleG = () => (
  <svg viewBox="0 0 48 48" className="h-8 w-8" aria-hidden="true">
    <path fill="#4285F4" d="M45.12 24.5c0-1.56-.14-3.06-.4-4.5H24v8.51h11.84c-.51 2.75-2.06 5.08-4.39 6.64v5.52h7.11c4.16-3.83 6.56-9.47 6.56-16.17z" />
    <path fill="#34A853" d="M24 46c5.94 0 10.92-1.97 14.56-5.33l-7.11-5.52c-1.97 1.32-4.49 2.1-7.45 2.1-5.73 0-10.58-3.87-12.31-9.07H4.34v5.7C7.96 41.07 15.4 46 24 46z" />
    <path fill="#FBBC05" d="M11.69 28.18C11.25 26.86 11 25.45 11 24s.25-2.86.69-4.18v-5.7H4.34C2.85 17.09 2 20.45 2 24s.85 6.91 2.34 9.88l7.35-5.7z" />
    <path fill="#EA4335" d="M24 10.75c3.23 0 6.13 1.11 8.41 3.29l6.31-6.31C34.91 4.18 29.93 2 24 2 15.4 2 7.96 6.93 4.34 14.12l7.35 5.7c1.73-5.2 6.58-9.07 12.31-9.07z" />
  </svg>
);

const GoogleReviews = () => {
  const { settings } = useSettings();
  if (!settings || !settings.google_enabled || !settings.google_url) return null;

  const rating = Number(settings.google_rating) || 0;
  const count = settings.google_review_count;

  return (
    <section className="py-16 bg-white" data-testid="google-reviews">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          <div className="bg-gradient-to-br from-slate-50 to-emerald-50/50 border border-slate-200 rounded-3xl p-8 md:p-10 flex flex-col md:flex-row items-center gap-8 text-center md:text-left shadow-sm">
            <div className="flex-shrink-0 flex flex-col items-center gap-3">
              <GoogleG />
              <span className="text-xs font-semibold text-slate-500 uppercase tracking-wider">
                {settings.google_label || 'Avis Google'}
              </span>
            </div>
            <div className="flex-1">
              <div className="flex items-center justify-center md:justify-start gap-3 mb-2">
                {rating > 0 && (
                  <span className="text-4xl font-bold text-slate-900" data-testid="google-rating">
                    {rating.toFixed(1).replace('.', ',')}
                  </span>
                )}
                <div className="flex gap-0.5">
                  {[1, 2, 3, 4, 5].map((i) => (
                    <Star
                      key={i}
                      className={`h-6 w-6 ${
                        i <= Math.round(rating) ? 'text-amber-400 fill-amber-400' : 'text-slate-300'
                      }`}
                    />
                  ))}
                </div>
              </div>
              {count != null && count !== '' && (
                <p className="text-slate-600" data-testid="google-count">
                  Basé sur <span className="font-semibold text-slate-800">{count}</span> avis clients vérifiés sur Google.
                </p>
              )}
            </div>
            <a
              href={settings.google_url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="google-reviews-link"
              className="flex-shrink-0 inline-flex items-center gap-2 bg-white border border-slate-300 hover:border-emerald-500 hover:text-emerald-700 text-slate-700 font-medium rounded-full px-6 py-3 transition-colors"
            >
              Voir nos avis
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GoogleReviews;
